import type { ColumnsType } from 'antd/es/table';

import { ConsumerApiKey } from '@page/credentials/api-key/api-key';
import { RoleTag } from '@page/credentials/credentials.page-style';

import { CredentialInterface } from '@interface/credential/credential.interface';

import { ConsumerId } from './consumer-id/consumer-id';
import { ConsumerLink } from './consumer-link/consumer-link';
import { ConsumerUrl } from './consumer-url/consumer-url';

export const consumerCredentialColumns: ColumnsType<CredentialInterface> = [
  {
    title: 'Role',
    dataIndex: 'role',
    key: 'role',
    width: 80,
    render: (role) => <RoleTag>{role.toLowerCase()}</RoleTag>,
  },
  {
    title: 'Api Key',
    dataIndex: 'apiKey',
    key: 'apiKey',
    render: (apiKey) => <ConsumerApiKey apiKey={apiKey} />,
  },
  {
    title: 'Consumer ID',
    dataIndex: 'consumer',
    key: 'consumer',
    render: () => <ConsumerId />,
  },
  {
    title: 'Auth URL',
    dataIndex: 'id',
    key: 'id',
    render: () => <ConsumerUrl />,
  },
  {
    key: 'id',
    width: 140,
    render: () => <ConsumerLink />,
  },
];
